export var COMBOBOX_EVENT_REASON = Object.freeze({
  AUTOCOMPLETE_AUTOMATIC: 'autocomplete automatic',
  CLEAR_INPUT: 'clear input',
  CLEAR_BUTTON: 'clear button',
  CLEAR_TAG: 'clear tag',
  CONTROLLED_OVERWRITE: 'controlled overwrite',
  FREEFORM: 'freeform',
  LISTBOX_EVENT: 'listbox event'
});